import React, { memo } from 'react';
import { Popup } from 'react-mapbox-gl';
import { makeStyles } from '@mui/styles';

import arrowPopup from '../../assets/arrowPopup.svg';
import palette from '../styles/palette';

import RequestPopupContent from './RequestPopupContent';

const useStyles = makeStyles({
  popup: {
    color: palette.typography.white.solid,
    zIndex: '4 !important',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '& .mapboxgl-popup-tip': {
      border: 'none',
      width: '18px',
      height: '28px',
      backgroundImage: `url(${arrowPopup})`,
    },
    '& .mapboxgl-popup-content': {
      background: 'transparent',
      padding: '0px !important',
      cursor: 'default',
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
});

const StopMarkerRequestPopup = ({ coordinates, onClose, stop }) => {
  const styles = useStyles();

  return (
    <Popup
      coordinates={coordinates}
      anchor={'left'}
      offset={[42, -16]}
      className={styles.popup}
    >
      <RequestPopupContent onClose={onClose} stop={stop} />
    </Popup>
  );
};

export default memo(StopMarkerRequestPopup);
